import {
  hasAlternateLangHref,
  getAlternateLangHref,
  getAlternateHrefs,
} from 'ha/modules/Hermes/selectors';
import { STATE_NAME } from './constants';
import * as reducerSelectors from './reducer';

const getLanguageSwitcherState = state => state[STATE_NAME];

export const getCurrentLanguageCode = state =>
  reducerSelectors.getCurrentLanguageCode(getLanguageSwitcherState(state));

export const getAvailableLanguages = state =>
  reducerSelectors.getAvailableLanguages(getLanguageSwitcherState(state));

export const isLanguageAvailable = (state, lang) =>
  reducerSelectors.isLanguageAvailable(getLanguageSwitcherState(state), lang);

const getLocalisedLocationWithoutDefault = (state, lang, currentLocation) => {
  if (!isLanguageAvailable(state, lang)) {
    return undefined;
  }

  // let's try to find the url in the localised locations.
  const localisedLocation = reducerSelectors.getLocalisedLocation(
    getLanguageSwitcherState(state),
    lang,
  );

  if (localisedLocation) {
    return `${localisedLocation}${currentLocation.search}`;
  }

  // let's check if the language is available in Hermes
  if (hasAlternateLangHref(state, lang, currentLocation.pathname)) {
    return `${getAlternateLangHref(state, lang)}${currentLocation.search}`;
  }

  return undefined;
};

export const getCurrentPageLanguages = (state, location) => {
  const languages = getAvailableLanguages(state);

  const alternateHrefs = getAlternateHrefs(state, location.pathname);

  if (alternateHrefs.length === 0) {
    return languages;
  }

  // if this is hermes page check whether platform-api url exists as well
  return languages.filter(lang =>
    getLocalisedLocationWithoutDefault(state, lang.code, location),
  );
};

export const getLocalisedLocation = (state, lang, currentLocation) => {
  if (!isLanguageAvailable(state, lang)) {
    return `${currentLocation.pathname}${currentLocation.search}`;
  }

  const localisedLocation = getLocalisedLocationWithoutDefault(
    state,
    lang,
    currentLocation,
  );

  if (localisedLocation) {
    return localisedLocation;
  }

  // the url was not found. Let's create it ourselves
  const regexp = new RegExp(
    `^/(${getAvailableLanguages(state)
      .map(({ code }) => code)
      .join('|')})(/?.+)`,
  );
  const langForUrl = lang === 'en' ? '' : `/${lang}`;
  const match = currentLocation.pathname.match(regexp);
  const nextPathname = match
    ? `${langForUrl}${match[2]}`
    : `${langForUrl}${currentLocation.pathname}`;

  return `${nextPathname}${currentLocation.search}`;
};
